/**
 * ver 0.1
 * author jack
 * ex)
 */
import React from 'react'

class Alink extends React.Component {
    render() {
        const children = this.props.children
        let _hostname = ''
        let attr = {}
        if (this.props.href) {
            attr.href = this.props.href
            let slashOf = attr.href.indexOf('//')
            if (slashOf === -1) {
                attr.href = '//'+attr.href
                _hostname = this.props.href.split('/')[0]
            } else if (slashOf === 0) {
                _hostname = this.props.href.split('/')[2]
            }
        }
        if (this.props.target) attr.target = this.props.target
        if (this.props.className) attr.className = this.props.className

        if (
            (this.props.target === undefined && window.location.hostname !== _hostname)
            || this.props.target === '_blank') {
            attr.target = '_blank'
            attr.rel = 'noopener noreferrer'
        }
        return <a {...attr}>{children}</a>
    }
}
export default Alink



// WEBPACK FOOTER //
// ./src/common/container/alink.js